import { useState } from 'react';
import Icon from '../../shared/components/Icons';
import { fmtDay, placeOf } from '../../shared/data/common';
import { airlineLogo } from './data';

export function AirlineLogo({ airline, size = 38 }) {
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size };
  return failed
    ? <span className="airline-logo" style={{ ...style, background: airline.color }}>{airline.code}</span>
    : <img className="airline-logo img" style={style} src={airlineLogo(airline.code)} alt={airline.name} onError={() => setFailed(true)} />;
}

export function SegmentTimeline({ segments, airline, date }) {
  return (
    <div className="timeline">
      {segments.map((s, i) => (
        <div key={i}>
          {s.isReturn && !segments[i - 1]?.isReturn && (
            <div className="tl-direction"><Icon name="swap" size={14} /> Return{s.date ? ` · ${fmtDay(s.date)}` : ''}</div>
          )}
          {s.layover && (
            <div className="layover"><Icon name="clock" size={14} /> {s.layover} layover in {s.from}</div>
          )}
          <div className="tl-seg">
            <div className="tl-airline"><AirlineLogo airline={airline} size={28} /><span className="small"><b>{airline.name}</b><br /><span className="muted">{s.flightNo}</span></span></div>
            <div className="tl-point">
              <b className="time">{s.dep}</b>
              <span className="small"><b>{s.fromCode || placeOf(s.from).code}</b> · {s.from}</span>
              <span className="muted small">{s.fromAirport || placeOf(s.from).airport}</span>
              {(s.date || (i === 0 && date)) && <span className="muted small">{fmtDay(s.date || date)}</span>}
            </div>
            <div className="tl-dur"><span className="muted small">{s.duration}</span><span className="path-line"><span className="plane"><Icon name="flights" size={13} /></span></span></div>
            <div className="tl-point">
              <b className="time">{s.arr}</b>
              <span className="small"><b>{s.toCode || placeOf(s.to).code}</b> · {s.to}</span>
              <span className="muted small">{s.toAirport || placeOf(s.to).airport}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

/** Flight booking summary used on review, confirmation and booking details pages. */
export default function FlightSummary({ summary: s }) {
  const pax = [
    s.pax.adults && `${s.pax.adults} Adult${s.pax.adults > 1 ? 's' : ''}`,
    s.pax.children && `${s.pax.children} Child${s.pax.children > 1 ? 'ren' : ''}`,
    s.pax.infants && `${s.pax.infants} Infant${s.pax.infants > 1 ? 's' : ''}`,
  ].filter(Boolean).join(', ');
  return (
    <div className="sum">
      <div className="sum-head">
        <div>
          <h3>{s.from} <Icon name="arrow" size={16} /> {s.to}</h3>
          <span className="muted small">{fmtDay(s.date)}{s.returnDate ? ` – Return ${fmtDay(s.returnDate)}` : ''} · {s.stops ? `${s.stops} stop` : 'Non-stop'} · {s.duration} · {s.cabin}</span>
        </div>
        <span className="tag">{s.fareName} fare</span>
      </div>
      <SegmentTimeline segments={s.segments} airline={s.airline} date={s.date} />
      <div className="sum-foot">
        <span><Icon name="bag" size={14} /> Cabin {s.baggage.cabin} · Check-in {s.baggage.checkin} per adult</span>
        <span><Icon name="user" size={14} /> {pax}</span>
      </div>
    </div>
  );
}
